// src/components/Exaustores/UnidadeItem/UnidadeItem.jsx
import React from "react";
import CircleStatus from "../statusExaustor/statusExaustor";
import { mapUnitStateToCircle } from "../../../utils/utilsExaustor";

/**
 * Item individual de unidade
 * @param {Object} unidade - Dados da unidade
 * @param {Function} onClick - Callback ao clicar na unidade
 */
const UnidadeItem = ({ unidade, onClick }) => {
  const circleStatus = mapUnitStateToCircle(unidade.state);

  return (
    <div className="unidade">
      <CircleStatus status={circleStatus} onClick={onClick} />
      <p>{unidade.id}</p>
    </div>
  );
};

export default UnidadeItem;